<template>
    <div :class="computed_cols + ' component-kira-select'">
        <div :class="(inline == null ? 'mb-3' : '') +' form-grupo neutron'">
            <label :for="computed_id" v-if="inline == null || inline == 'true'">
                <span class="text-wrap">
                    {{computed_title}}
                </span>
                <i v-if="required == '' || required == null || required == 'true'" 
                    class="fas fa-shield-alt"></i>
            </label>
            <select class="selectpicker form-control"
                :id="computed_id"
                :name="computed_name">
                <option v-for="item in options" 
                    :key="item.id" 
                    :value="item.id">
                    {{item.nombre}}
                </option>
            </select>
            <!-- <spinner-clip-loader class="" v-show="loading"></spinner-clip-loader> -->
        </div>
    </div>
</template>

<script>
import spinnerClipLoader from 'vue-spinner/src/ClipLoader.vue'
import selectpicker from "bootstrap-select";
import Axios from 'axios';

export default {
    components: {
        spinnerClipLoader
    },
    props: [
        'id',
        'title',
        'required',
        'inline',
        'weight',
        'vertical',
        'value',
        'parent',
        'name',
    ],
    computed: {
        computed_id() {
            if(this.id == undefined) {
                return 'atributo_id';
            } else {
                return this.id;
            }
        },
        computed_name() {
            if(this.name == undefined) {
                return 'atributo_id';
            } else {
                return this.id;
            }
        },
        computed_title() {
            if(this.title == undefined) {
                return 'Grado';
            } else {
                return this.title;
            }
        },
        computed_cols() {
            switch (this.weight) {
                case '0':
                    return 'col';            
                case '1':
                    return 'col-12';            
                case '2':
                    return 'col-xs-12 col-sm-6';            
                case '3':
                    return 'col-xs-12 col-sm-6 col-lg-4';            
                case '4':
                    return 'col-xs-12 col-sm-6 col-lg-4 col-xxl-3'; 
                case 'false':
                    return '';           
                default:
                    return 'col-xs-12 col-sm-6 col-lg-4';
            }
        },
        computed_parent() {
            if(this.parent == undefined) {
                return 'programa_id';
            } else {
                return this.parent;
            }
        },
    },
    data() { return {
        options: [],
        default: null,
        loading: false,
        first: true,
    }},
    mounted() {
        const vm = this;
        const select = $('#'+this.computed_id);

        select.on('change', function() {
            vm.$emit('input', select.val());
            vm.emitrCambio();
        });

        vm.load();
        if(vm.force == '' || vm.force == 'true' || vm.force == true) {
            setTimeout(() => {
                vm.emitrCambio();
            }, 1000);
        }

        // Kira Select
        this.$parent.$on('broadcastRefreshSelection', function(who, val) {
            if(vm.computed_parent == who) {
                if(!vm.first) {
                    if(val == null) {
                        vm.options = [];
                    } else {
                        vm.load();
                    }
                } else {
                    vm.first = false;
                }
            }
        });

        // Neutron Select
        this.$parent.$on('broadcastPadreCambio', function(padre) {
            if(Array.isArray(vm.computed_parent)) {
                vm.computed_parent.forEach(item => {
                    if(item == padre) {
                        vm.load();
                    }
                });
            } else {
                if(vm.computed_parent == padre) {
                    vm.load();
                }
            }
        });
    },
    methods: {
        async load() {
            const select = $('#'+this.computed_id);

            this.loading = true;
            await this.get();
            
            select.selectpicker('val', this.default);
            // select.selectpicker('val', '');
            select.selectpicker('refresh');

            this.$emit('input', select.val());
            this.emitrCambio();
            this.loading = false;
        },
        async get() {     
            const parent = !this.first ? ('/' + $('#'+this.computed_parent).val()) : '';
            const route = '/atributos/directiva'+parent;

            await Axios.get(route).then(res => {
                this.options = res.data.atributos;
                this.default = res.data.default;
                this.first = false;
            }).catch(e => {

            });
        },
        emitrCambio() {
            const select = $('#'+this.computed_id);

            // Kira Components
            this.$parent.$emit('emitRefreshSelection', this.computed_id, select.val());
            // Neutron Components
            this.$parent.$emit('padreCambio', this.computed_id);
        },
    },
}
</script>